import React ,{ useState, useEffect } from 'react'
import '../Css/Course.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCircleDot, faList,faTag,faCalendarCheck,faLocationDot} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Seminar from './Seminar';
import MasterBanner from './MasterBanner';

// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';

function Course() {
  const courseApply = () => {
    const url = "https://www.homerepairlearning.com/courseX.php?lessonCode=HRE01&courseCode=HRE";
    window.open(url,'_blank');
  }
  const seminarRegist = () => {
    const url = "https://homerepairlearning.com/seminarApply.php";
    window.open(url, '_blank');
  }  

   const courseData = {
    name: "維修王認證課程 - 家居維修師傅實務培訓",
    description: "由逾十年資深導師親自教授，涵蓋水電、油漆及裝修實戰技術。課程專為想入行或創業的學員設計，提供專業認證及接單平台支援。",
    providerName: "維修王",
    url: "https://homerepairexperthk.com"
  };
   
  
  const [result, setResult] = useState([]);

  useEffect(() => {
    let resultData = [];
    let fData = new FormData;
    const url = "https://homerepairlearning.com/getHRE.php";
    async function postData() {
        const response = await axios.post(url,fData);
        resultData = response.data;
        setResult(resultData);
        console.log("Course Response",response);

    }
    postData();
  }, []);
  console.log("Course Result", result);

  return (
  <div>
      <Helmet>
        <title>家居維修認證課程 | 維修王：助你掌握水電油漆技能，入行創業首選</title>
        <meta name="description" content={courseData.description} />
        <meta property="og:title" content="【維修王課程】零基礎入行，成為專業家居維修師傅" />
        <meta property="og:description" content="專業導師手把手教學，由理論到實戰，助你開展家居維修事業。" />
        <meta property="og:image" content="https://homerepairexperthk.com" />
        <meta property="og:url" content="https://homerepairexperthk.com" />
        {/* Course Schema JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Course",
            "name": courseData.name,
            "description": courseData.description,
            "provider": {
              "@type": "Organization",
              "name": courseData.providerName,
              "sameAs": "https://homerepairexperthk.com"
            },
            "url": courseData.url
          })}
        </script>
      </Helmet>
     
      <div className="Course-Wrapper">
      <div className="Course-Content">
        
        <div className="Course-Body">
            <div className="Course-Header-Image">
              <img src={require('../Image/Course.png')} style={{width:'1000px',height:'300px'}} alt="維修王培訓課程"/>
            </div>
            <MasterBanner/>
            <div className="Course-Body-Context">
                <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;掌握專業技能，投身熱門行業！【維修王】專業培訓課程現正招生 </div>  
                <div className="Course-Body-Content">
                  
                  <p>
                    您是否對家居維修服務充滿熱誠，渴望加入這個需求穩定的行業？或是您已是業內人士，希望提升技術水平、獲取劃一標準認證？我們的 專業培訓課程 正是為您量身打造！
                  </p>

                  <div className="Course-Body-SubHeader">
                      專為有志之士與業內人員設計的實用課程
                  </div>
                  <div className="Content">
                    <li>
                      <span id="ContentHeader">為有志入行者鋪路：</span> 本課程專為有意投身家居維修服務領域的朋友設計，提供全面、實用的專業培訓。從基礎知識到進階技巧，助您快速掌握核心技能，自信入行。
                    </li>
                    <br/>
                    <li>
                       <span id="ContentHeader">為業內人員提升標準：</span> 我們致力於提升家居維修服務的整體質素，為行內人員提供劃一標準的技術規範與操作流程培訓。透過系統化學習，統一服務水平，提升專業形象與客戶信任度。
                    </li>
                  </div>
                  
                </div>    
            </div>  

            <div className="Course-Body-Context">
              <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;上課實況 </div>  
                <div className="Course-Body-Content">
                  <div className="Course-Image">
                    <img src={require('../Image/PhotoGallery.png')} className="responsive-image" alt="維修王培訓課程" />
                  </div>
                  
                </div>
            </div>
       
            <div className="Course-Body-Context" id="Course-Body-Context-Full">
              <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;十年經驗匠心傳承，品質保證 </div>  
                <div className="Section1">
                  <div className="Course-Body-Content">
                    <p>
                      課程的核心價值在於其深厚的實戰根基。所有內容均由在家居維修及裝修行業深耕逾十年的資深導師親自設計及教導。導師不僅擁有豐富的現場經驗，更深刻理解行業痛點與客戶需求，能將最實用、最前沿的技術和服務標準傾囊相授。
                    </p>
                  </div>
                  <div className="JoinUs-image">
                    <img src={require('../Image/rating.png')} className='responsive-image' alt="維修王培訓課程" />
                  </div>
                </div>
            </div>
              <div className="Course-Body-Context" id="Course-Body-Context-Mobile">
              <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;十年經驗匠心傳承，品質保證 </div>  
                <div className="Section1">
                  <div className="Course-Body-Content">
                    <p>
                      課程的核心價值在於其深厚的實戰根基。所有內容均由在家居維修及裝修行業深耕逾十年的資深導師親自設計及教導。導師不僅擁有豐富的現場經驗，更深刻理解行業痛點與客戶需求，能將最實用、最前沿的技術和服務標準傾囊相授。
                    </p>
                  </div>
                  <div className="JoinUs-image">
                    <img src={require('../Image/rating.png')} className='responsive-image' alt="維修王培訓課程" />
                  </div>
                </div>
            </div>
            <MasterBanner/>
          
                                  
            <div className="Course-Body-Context">
              <div className="Course-Body-Header">課程內容紮實，聚焦實戰應用&nbsp;<FontAwesomeIcon icon={faList} /> </div>  
                <div className="Course-Body-Content">
                  <div className="Course-Body-List">
                    <div className="Course-Body-ListItem">
                      <ul>
                        <li>玻璃膠技巧</li>
                        <li>安裝鋁質天花</li>
                        <li>安裝鋁質天花</li>
                        <li>安裝廁所五金、瓦仔轉運用</li>
                        <li>安裝座廁（更換零件）</li>
                        <li>安裝洗手盆水龍頭</li>
                        <li>安裝浴缸水龍頭</li>
                        <li>更換洗手盆去水及隔氣</li>
                        <li>更換廁所門鎖</li>
                        <li>更換廁所抽氣扇</li>
                      </ul>
                    </div>
                    <div className="Course-Body-Item">
                      <ul>
                        <li>更換洗手盆水龍頭</li>
                        <li>更換抽油煙機</li>
                        <li>更換櫃桶路軌</li>
                        <li>更換門鉸</li>
                        <li>更換鋁窗鉸</li>
                        <li>更換鋁窗七字鉸</li>
                        <li>安裝吊櫃技巧</li>  
                        <li>安裝木地板</li>  
                        <li>修補瓷磚</li>
                        <li>批灰掃乳膠漆</li>
                      </ul>  
                    </div>  
                    <div className="Course-Body-Item">
                      <ul>
                        <li>石屎剝落維修</li>
                        <li>淘寶安裝燈</li>
                        <li>淘寶砌傢俬</li>
                        <li>清拆技巧</li>
                        <li>清潔家居技巧</li>
                        <li>清洗冷氣</li>  
                        <li>裝修維修報價技巧</li>  
                      </ul>  
                    </div>  
                </div>
            </div>
          </div>
          <div className="Course-Body-Context">
            <div className="Course-Detail-Wrapper">
              <div className="Course-Detail">
                <div className="Course-Detail-Header">
                  <div className="Course-Header-Logo">
                    <FontAwesomeIcon icon={faTag} style={{ color: "00695c", }} />
                  </div>  
                  <div className="Course-Header-Text">
                    費用
                  </div>  
                </div>
                <div className="Course-Detail-Body">
                  HK$17,800
                </div>
              </div>
              <div className="Course-Detail">
                <div className="Course-Detail-Header">
                  <div className="Course-Header-Logo">
                    <FontAwesomeIcon icon={faCalendarCheck} style={{ color: "#1565c0", }}/>
                  </div>
                  <div className="Course-Header-Text">
                    上課時間
                  </div>
                </div>
                <div className="Course-Detail-Body">
                  <div id="Course-Time-Table">
                    {result.map(items => {
                    return (
                      <>
                        <div> {items.CourseDate1} | 星期{items.DayOfWeek1} |{items.CourseTime1}</div>
                        <div> {items.CourseDate2} | 星期{items.DayOfWeek1} |{items.CourseTime1}</div>  
                        <div>  {items.CourseDate3} | 星期{items.DayOfWeek1} |{items.CourseTime1}</div> 

                      </>
                      )
                    })}  
                  </div>  
                </div>
                <div className="Course-Detail-Body">
                  <div id="Course-Time-Table-Mobile">
                  {result.map(items => {
                    return (
                      <>
                        <div className="Course">
                          <div>{items.CourseDate1}</div>
                          <div>星期{items.DayOfWeek1} </div>
                          <div>{items.CourseTime1}</div>
                        </div>
                        <div className="Course">
                          <div>{items.CourseDate2}</div>
                          <div>星期{items.DayOfWeek1} </div>
                          <div>{items.CourseTime1}</div>
                        </div>
                        <div className="Course">
                          <div>{items.CourseDate3}</div>
                          <div>星期{items.DayOfWeek1} </div>
                          <div>{items.CourseTime1}</div>
                        </div>
                      </>
                      )
                  })}
                  </div>  
                </div>  
              </div>
              <div className="Course-Detail">
                  <div className="Course-Detail-Header">
                    <div className="Course-Header-Logo">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#e91e63", }} />
                    </div>  
                    <div className="Course-Header-Text">
                      上課地點
                    </div>
                  </div>
                  <div className="Course-Detail-Body">
                    新蒲崗八達街9號,宏基中心二期-601室
                  </div>
              </div>
            </div>  
          </div>  
          <div className="Course-Body-Context">
              <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;立即行動，開啟您的家居維修專業之路！</div>  
                <div className="Course-Body-Content">
                  <p>
                    無論您是尋求轉職、入行，或是希望精進技術、符合行業劃一標準的現職人員，這個由經驗豐富導師設計的專業培訓課程，都是您提升競爭力、在家居維修服務領域站穩腳步的最佳投資。
                  </p>
                </div>
            </div>
          
          <div className="Course-Body-Context">
            <div className="Course-Button">
               <button className="Button-Body" onClick={courseApply}>立即報名 &nbsp; <FontAwesomeIcon icon={faAngleRight} style={{color:"#ffffff",}} /></button>
            </div>
          </div>  
          
          <Seminar/>
          
      
        </div>
      </div>
      </div>
    </div>  
  )
}

export default Course
